import styled, { css } from "styled-components";

interface SearchBoxStyleProps {
  $size?: "md" | "lg";
}

export const Search = styled.div`
  gap: 4px;
  display: flex;
  flex-direction: column;

  &:has(input:focus) {
    span {
      color: ${(props) => props.theme.colors.primary100};
    }
  }
`;

export const SearchLabel = styled.span`
  color: ${(props) => props.theme.colors.inputLabel};
  font-size: 1.2rem;
  font-weight: 600;
`;

export const SearchInput = styled.div<SearchBoxStyleProps>`
  width: 100%;
  border: 1px solid ${(props) => props.theme.colors.inputBorder};
  display: grid;
  box-sizing: content-box;
  align-items: center;
  border-radius: 6px;
  grid-template-columns: calc(100% - 56px) 56px;

  input {
    border: none;
    background: none;

    &:focus {
      border: none;
    }
  }

  button {
    padding: 0;
  }

  &:has(input:focus) {
    border: 2px solid ${(props) => props.theme.colors.primary100};

    button {
      svg {
        path {
          fill: ${(props) => props.theme.colors.primary100};
        }
      }
    }
  }

  ${(props) =>
    props.$size === "md" &&
    css`
      height: 48px;
    `}

  ${(props) =>
    props.$size === "lg" &&
    css`
      height: 56px;
    `}
`;
